var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyHelmet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17C1.97386 17 1.75 17.2239 1.75 17.5V20C1.75 21.1046 2.64543 22 3.75 22C4.85457 22 5.75 21.1046 5.75 20C5.75 19.4477 6.19772 19 6.75 19H17.25C18.1424 18.9993 18.9668 18.5229 19.413 17.75C19.5023 17.5953 19.5023 17.4047 19.413 17.25C19.3237 17.0953 19.1586 17 18.98 17H2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13.5H20.75V12.485C20.7055 7.1534 16.7175 2.67997 11.426 2.02598C10.5754 1.9148 9.71644 2.15855 9.051 2.69998L6.851 4.52398C3.51815 5.75998 1.29875 8.93038 1.278 12.485C1.00836 12.4818 0.748514 12.5859 0.555694 12.7744C0.362874 12.9629 0.252901 13.2203 0.25 13.49V14.49C0.251847 14.7602 0.361186 15.0186 0.553875 15.2081C0.746564 15.3976 1.00676 15.5026 1.277 15.5H22.75C23.3023 15.5 23.75 15.0523 23.75 14.5C23.75 13.9477 23.3023 13.5 22.75 13.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyHelmet);
export default __webpack_public_path__ + "static/media/safetyHelmet.0b436968.svg";
export { ForwardRef as ReactComponent };